import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CropSquareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_square"}/>
}
